import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import HotRecommendSection from './components/HotRecommendSection';
import DailyUpdateSection from './components/DailyUpdateSection';
import CategoryNavSection from './components/CategoryNavSection';
import LatestAnimeSection from './components/LatestAnimeSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  useEffect(() => {
    document.title = '51动漫 | 51动漫网 - 国产动漫每日更新在线观看';

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', '51动漫网提供国产动漫在线观看与网站入口，每日更新热门番剧、经典国漫、实时动漫视频资源。51动漫官网、51动漫在线观看、51动漫国产精品入口，方便动漫迷快速找到观看路径。');
    setMeta('keywords', '51动漫,51动漫网,51动漫在线观看,51动漫网站,51动漫官网,51动漫国产精品入口,国漫在线,动漫资源');
    setMeta('og:title', '51动漫 | 51动漫网 - 国产动漫每日更新在线观看', true);
    setMeta('og:description', '51动漫网提供国产动漫在线观看与网站入口，每日更新热门番剧、经典国漫、实时动漫视频资源。', true);

    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) existingScript.remove();

    const jsonLd = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebSite',
          name: '51动漫',
          url: 'http://heiliaochigua.cn/',
          description: '51动漫网提供国产动漫在线观看与网站入口，每日更新热门番剧、经典国漫、实时动漫视频资源。',
          inLanguage: 'zh-CN',
        },
        {
          '@type': 'Organization',
          name: '51动漫',
          url: 'http://heiliaochigua.cn/',
          description: '国内领先的国产动漫在线观看平台',
        },
        {
          '@type': 'WebPage',
          name: '51动漫 - 首页',
          description: '51动漫网首页，提供国产动漫在线观看入口，每日更新热门番剧推荐',
          url: 'http://heiliaochigua.cn/',
          isPartOf: { '@id': 'http://heiliaochigua.cn/#website' },
        },
      ],
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);
  }, []);

  return (
    <main>
      <HeroSection />
      <HotRecommendSection />
      <DailyUpdateSection />
      <CategoryNavSection />
      <LatestAnimeSection />
      <CTASection />
    </main>
  );
}